import 'zone.js/plugins/zone-error';

export const environment = {
    production: false,
    appHostName: 'otzy-local',
};
